

/**
 * Smaller miscellanious utility stuff
 * */



let debounceTimeout: any // NodeJs.Timeout throws namespace error during compilation 
/** Debounce method */
export const debounce = (callback: any, options?: { payload?: any, delay?: number }) => {
    let delay = options?.delay || 1000

    clearTimeout(debounceTimeout)
    debounceTimeout = setTimeout(() => {
        callback(options?.payload)
    }, delay)
}





/** string convention mutation methods */
export const toCamelCase = (v: string) => v.replace(/-\w/g, repUpper),
    toPascalCase = (v: string) => v.replace(/(^\w|-\w)/g, repUpper),
    toKebabCase = (v: string) => v.replace(/(^.[A-Z])/g, repDash)

const repUpper = (v: string) => v.replace(/-/, '').toUpperCase(),
    repDash = (v: string) => v.replace(/[A-Z]/, '-' + v.toLowerCase())


export const stringTo = {
    camelCase: toCamelCase,
    pascalCase: toPascalCase,
    kebakCase: toKebabCase
}





/**
 * returns a hashed id of specified length (default: 6)
 */
export const uid = (l: number = 6): string => {
    let ts = Date.now(),
        uid = ((ts << 5) + ts).toString(32) + (16 ** 16 * Math.random() << 2).toString(32)
    return uid.substring(Math.round(uid.length / 2 - l / 2) + 2, Math.round(uid.length / 2 + l / 2) + 2)
}


/** simple method for escaping regexp special characters */
export const escapeRegExpString = (string: string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')



/**
 * 
 * @param tag - element tag
 * @param classes - setAttr 'style' string
 * @param inlineStyles - setAttr 'style' string
 */
export const newDomElement = (tag: string, options: { classes?: string, inlineStyles?: string } = {}) => {
    let el = document.createElement(tag),
        { classes, inlineStyles } = options

    if (classes)
        el.setAttribute('class', classes)

    if (inlineStyles)
        el.setAttribute('style', inlineStyles)

    return el
}

/**
 * A simple set proxy trap
 * @param obj - target object
 * @param handlers - methods to process value changes of obj properties with same key
 * @param options - alwaysNotify [ default: false ]
 */
export const proxySet = <T extends object>(obj: T, handlers: { [ k in keyof T ]?: (v: T[ k ]) => void }, options: { alwaysNotify?: boolean } = {}) =>
    new Proxy(obj, {
        set(o, p, v, r) {
            if (!options.alwaysNotify && o[ p ] === v) return Reflect.set(o, p, v, r)
            typeof handlers[ p ] === 'function' &&
                handlers[ p ](v)
            return Reflect.set(o, p, v, r)
        }
    })




export const rs_observer = new ResizeObserver((entries: any[]) => {
    for (let entry of entries) {
        entry.target.setCustomProperty()
    }
})